import { FC, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { FormTextEditor } from '../../../../../components/text-editor/index';
import { useReactForm } from '../../../../../hooks/index';
import { FormControlButtons } from '../components/form-control-buttons';
import { PerkFormSchema, perkFormSchema } from '../form.validation';
import { PerkStepFormProps } from './steps.types';

export const StepThree: FC<PerkStepFormProps> = ({
  onSubmit,
  handlePrevStep,
  patchStep,
  defaultData: { stepThree },
}) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
    reset,
  } = useReactForm({
    schema: perkFormSchema.shape.stepThree,
  });

  useEffect(() => {
    if (!stepThree) return;
    reset(stepThree);
  }, [stepThree, reset]);

  const submitHandler = (data: PerkFormSchema['stepThree']) => {
    onSubmit('stepThree', data);
  };

  const values = useWatch({ control });

  useEffect(() => {
    const id = setTimeout(() => {
      patchStep({ stepThree: values });
    }, 500);

    return () => clearTimeout(id);
  }, [patchStep, values]);

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-4">
        <FormTextEditor
          control={control}
          label="Offer Description"
          maxLength={700}
          name="offerDescription"
          placeholder="Offer Description"
        />
      </div>

      <FormControlButtons
        disabled={!isValid}
        handleNext={handleSubmit(submitHandler)}
        handlePrev={handlePrevStep}
      />
    </>
  );
};
